import { UserDefinedFlagType } from "@store/reducers/userDefinedFlags.reducer";

export const SCOPE_OPTIONS = [
    { label: "Current Player", value: "current:player" },
    { label: "Current Player Position", value: "current:player_position" },
    { label: "Full Team", value: "full-team:full-team" },
];

export const STAT_OPTIONS = [
    { label: "Avg", value: "avg" },
    { label: "Best", value: "best" },
    { label: "Sum", value: "sum" },
];

// Display-label overrides for variable options coming from the backend
// The one variable a wellness operand can resolve; shown as "Current date value".
export const CURRENT_DATE_VARIABLE = 'latest';

export const VARIABLE_LABEL_OVERRIDES: Record<string, string> = {
    latest: "Current date value",
    min: "All Time Minimum",
    max: "All Time Maximum",
};

export const FLAG_TYPE_LOGIC: UserDefinedFlagType = "logic";
export const FLAG_TYPE_COACH: UserDefinedFlagType = "coach";

export const FLAG_TYPE_OPTIONS: { label: string; value: UserDefinedFlagType }[] = [
    { label: "Logic", value: FLAG_TYPE_LOGIC },
    { label: "Coach", value: FLAG_TYPE_COACH },
];

export const FLAG_TYPE_HINT =
    "Logic flags are raised automatically from a rule you build. Coach flags carry no rule — you tag players by hand.";

// The backend writes different Flags rows per type, so an existing flag's type is fixed.
export const FLAG_TYPE_LOCKED_HINT =
    "A flag's type can't be changed after it's created. Create a new flag instead.";
